import gql from 'graphql-tag';

const DELETE_PROJECT_CATEGORY = gql`
  mutation deleteProjectCategory (
    $id: Float!
  ) {
    deleteProjectCategory (id: $id)
  }
`;

export default DELETE_PROJECT_CATEGORY;
